  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Puntos de Recogida</li>
            <li class="breadcrumb-item">Búsqueda de Puntos de Recogida</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda de puntos de recogida</h2>
          <button *ngIf="canAccessCreate()" (click)="openModalPreliminary()" type="button" class="btn btn-primary"
            data-toggle="modal"><span class="icon-add"></span>Alta
            Preliminar</button>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
      <!-- Barra de filtros aplicados -->
  <div class="filtros-bar">
    <div class="filtros-aplicados">
      <span class="filtros-label">Filtros aplicados</span>
      <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
        {{filtro.label}}
        <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
      </span>
    </div>
    <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
      <mat-icon>tune</mat-icon>
      {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
    </button>
  </div>
    <!-- Formulario de búsqueda -->
    <form *ngIf="mostrarFiltros" class="container-fluid form-search py-3"[formGroup]="searchForm">
      <div class="row form">
        <div style="flex: 1 1 200px; max-width: 250px;">
          <label for="idPuntoRecogida">ID. Punto de Recogida </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idPuntoRecogida" id="idPuntoRecogida" placeholder="ID. Punto de Recogida"
                type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="codigo_documento">Documento (NIE,NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento" id="codigo_documento" placeholder="Documento (NIE,NIF)"
                type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 300px; max-width: 400px;">
          <label for="razon_social">Razón Social </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="razon_social" id="razon_social" placeholder="Razón Social" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 300px; max-width: 400px;">
          <label for="denominacion">Denominación </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="denominacion" id="denominacion" placeholder="Denominación" type="text">
            </mat-form-field>
          </div>
        </div>


        <div style="flex: 1 1 280px; max-width: 300px;">
          <label for="comunidad_autonoma">Comunidad Autónoma (Dirección Física)</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="comunidad_autonoma" id="comunidad_autonoma" placeholder="-- Comunidad --" [compareWith]="compareComunidad">
                <ngx-mat-select-search [formControl]="searchControl" (searchChange)="filterComunidades($event)"
                  [placeholderLabel]="'Buscar'" [noEntriesFoundLabel]="' No se han encontrado resultados'">
                </ngx-mat-select-search>
                <mat-option *ngFor="let comunidad of filteredComunidades" [value]="comunidad">
                  {{ comunidad.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 300px;">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple [compareWith]="compareEstado">
                <mat-option *ngFor="let des of estadosArray" [value]="des">
                  {{ des.descripcionCorta }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 250px;">
          <label for="nima">NIMA </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nima" id="nima" placeholder="Nima" type="text">
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;">
          <label for="resiPeligrosos">Residuos Peligrosos</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="resiPeligrosos" id="resiPeligrosos" placeholder="Seleccionar">
                <mat-option *ngFor="let item of residuosOptionArray" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('resiPeligrosos')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'resiPeligrosos')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>


        <div style="flex: 1 1 450px; max-width: 480px;">
          <label for="cnae">CNAE </label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination [endPointFilter]="cnaeEndpoint" [multiple]=true [updateList]="updateList"
              [descripcion]="getCnaDescription" [formControlNameSelect]="getFormControl('cnae')"
              [objQueryName]="getCnaeObjectQuery" [placeHolder]="'-- CNAE --'" [customClass]="rightHolder('cnae')">
            </lib-ge-select-pagination>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('PR-ENV-GEST') ||  this.canViewResource('PR-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="this.canViewResource('PR-ENV-GEST') ||  this.canViewResource('PR-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
              <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
        <div class="text-right">
          <div class="d-inline">

            <div class="d-inline dropdown show">
              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario,</p>
        <p class="mensaje-linea">o cree un nuevo punto de recogida en "Alta Preliminar"</p>
      </div>
    </ng-template>
  </div>
